const resultsView = {
  en: {
    resultsViewPage: {
      title: "Election Results",
      subtitle: "View and manage submitted results",
      verificationPortal: "Verification Portal",
      addResult: "Add Result",
      notePrefix: "Note:",
      noteBody: "All submitted results must be verified and approved before being counted in official tallies. Results with \"Awaiting Verification\" status are pending approval in the",
      noteLink: "Verification Portal",
      filters: "Filters",
      searchPlaceholder: "Search...",
      electionType: "Election Type",
      region: "Region",
      status: "Status",
      clearFilters: "Clear all filters",
      noResults: "No results found",
      submitFirst: "Submit First Result",
      pollingStation: "Polling Station",
      regionDivision: "Region / Division",
      election: "Election",
      votesCast: "Votes Cast",
      validVotes: "Valid Votes",
      actions: "Actions",
      view: "View",
      resultDetails: "Result Details",
      location: "Location",
      registered: "Registered",
      valid: "Valid",
      rejected: "Rejected",
      votesByCandidate: "Votes by Candidate",
      candidateN: "Candidate {{n}}",
      votesCount: "{{count}} votes",
      resultSheetPhoto: "Result Sheet Photo",
      resultSheetAlt: "Result sheet",
      notes: "Notes",
      submittedAt: "Submitted: {{date}}",
      electionTypes: {
        presidential: "Presidential", parliamentary: "Parliamentary", senatorial: "Senatorial",
        regional: "Regional", council: "Council"
      },
      statuses: {
        pending: "Pending", verified: "Verified", disputed: "Disputed", approved: "Approved",
        certified: "Certified", rejected: "Rejected", correctionNeeded: "Correction Needed",
        awaitingVerification: "Awaiting Verification"
      }
    }
  },
  fr: {
    resultsViewPage: {
      title: "Résultats électoraux",
      subtitle: "Consultez et gérez les résultats soumis",
      verificationPortal: "Portail de vérification",
      addResult: "Ajouter un résultat",
      notePrefix: "Remarque :",
      noteBody: "Tous les résultats soumis doivent être vérifiés et approuvés avant d'être comptabilisés dans les totaux officiels. Les résultats au statut « En attente de vérification » sont en attente d'approbation dans le",
      noteLink: "Portail de vérification",
      filters: "Filtres",
      searchPlaceholder: "Rechercher...",
      electionType: "Type d'élection",
      region: "Région",
      status: "Statut",
      clearFilters: "Effacer tous les filtres",
      noResults: "Aucun résultat trouvé",
      submitFirst: "Soumettre le premier résultat",
      pollingStation: "Bureau de vote",
      regionDivision: "Région / Département",
      election: "Élection",
      votesCast: "Votes exprimés",
      validVotes: "Votes valides",
      actions: "Actions",
      view: "Voir",
      resultDetails: "Détails du résultat",
      location: "Localisation",
      registered: "Inscrits",
      valid: "Valides",
      rejected: "Rejetés",
      votesByCandidate: "Votes par candidat",
      candidateN: "Candidat {{n}}",
      votesCount: "{{count}} votes",
      resultSheetPhoto: "Photo du procès-verbal",
      resultSheetAlt: "Procès-verbal",
      notes: "Notes",
      submittedAt: "Soumis le : {{date}}",
      electionTypes: {
        presidential: "Présidentielle", parliamentary: "Législative", senatorial: "Sénatoriale",
        regional: "Régionale", council: "Municipale"
      },
      statuses: {
        pending: "En attente", verified: "Vérifié", disputed: "Contesté", approved: "Approuvé",
        certified: "Certifié", rejected: "Rejeté", correctionNeeded: "Correction requise",
        awaitingVerification: "En attente de vérification"
      }
    }
  }
};

export default resultsView;
